<template>
  <div class="home-container">
    <!-- Carrousel de vidéos -->
    <div class="carousel">
      <div class="carousel-videos" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div v-for="(video, index) in videos" :key="index" class="carousel-video">
          <video :src="video" controls autoplay muted loop playsinline webkit-playsinline
                 @dblclick="disableFullscreen" id="VideoWorker-0" class="video-player"></video>
          <!-- Texte affiché devant les vidéos -->
          <div class="carousel-text">
            <h1 class="welcome-title">BIENVENUE CHEZ SOCIETE SUPRACARE</h1>
            <p class="welcome-description">
              Supracare est votre partenaire de confiance pour des équipements de laboratoire,
              consommables, produits chimiques, réactifs et compléments alimentaires de haute qualité.
            </p>
            <!-- Boutons sous le texte -->
            <div class="button-group">
              <a href="http://www.shop.supracare.ma/produits" target="_blank"  class="custom-button">Produits de laboratoire</a>
              <p class="button-description">Découvrez nos derniers produits de laboratoire.</p>
              <a href="http://www.shop.supracare.ma/vitamines-mineraux" target="_blank"  class="custom-button">Compléments alimentaires</a>
              <p class="button-description">Découvrez notre gamme de compléments alimentaires.</p>
            </div>
                <div class="brochure-section">
            <h2>Téléchargez notre brochure</h2>
           <a href="/Brochure materiel.pdf" download class="brochure-button">
          <i class="fas fa-file-pdf"></i> Brochure Equipements Labo</a>
          </div>
          </div>
        </div>
      </div>

      <div class="carousel-dots">
        <span
          v-for="(video, index) in videos"
          :key="index"
          :class="{ 'active': currentIndex === index }"
          class="carousel-dot"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>

    <!-- Paragraphe avec image -->
    <div class="welcome-section">
      <div class="welcome-content">
        <div class="welcome-image-container">
          <h2 class="welcome-heading">Bienvenue chez notre entreprise</h2>
          <img src="@/assets/SUP1.png" alt="Image" class="welcome-image">
        </div>
        <br />
        <p class="welcome-text">
          Avec Supracare, accédez à une gamme complète de produits essentiels pour vos opérations. 
          Des équipements de laboratoire aux compléments alimentaires en passant par les produits chimiques et les réactifs,
          nous vous fournissons tout ce dont vous avez besoin pour exceller dans votre domaine.   
    
            Grâce à notre réseau d’importation et d’exportation, 
            nous assurons la disponibilité et la fiabilité de nos produits dans le monde entier. Si vous avez des besoins particuliers ou des questions,
            notre équipe est toujours prête à vous offrir le meilleur service possible.
         
          <button @click="toggleShowMore" class="read-more-btn">
            Savoir plus
          </button>
          </p>

      </div>
    </div>
    
                <!-- Slider d'images en mouvement -->

   <h2 class="product-title">NOS PRODUITS</h2>           
   <div class="product-wrapper">
    <div class="product-container">
        <div class="product"><img decoding="async" src="@/assets/glove-latex.jpg" alt="Product 1"><h4>Glove Latex</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Vacutest.jpg" alt="Product 4"><h4>Tubes sous vide</h4><p></p></div>
         <div class="product"><img decoding="async" src="@/assets/LINE-Automation-2.png" alt="Product 8"><h4>LINE Automation</h4></div>
        <div class="product"><img decoding="async" src="@/assets/AKLIDES.png" alt="Product 9"><h4>Analyzer</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Micropipette.jpg" alt="Product 3"><h4>Micropipette</h4></div>
         <div class="product"><img decoding="async" src="@/assets/FLACON-BOUCHON-ROUGE.jpg" alt="Product 2"><h4>Flacon</h4><p></p></div>
        <div class="product"><img decoding="async" src="@/assets/BOITE-DE-PETRI.jpg" alt="Product 5"><h4>Boite De Petri</h4></div>
        <div class="product"><img decoding="async" src="@/assets/goodlife.png" alt="Product 11"><h4>Goodlife</h4></div>
        <div class="product"><img decoding="async" src="@/assets/REACTIF-.jpg" alt="Product 7"><h4>Réactifs</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Multi-analyzer.png" alt="Product 10"><h4>Multi analyzer</h4></div>
        <div class="product"><img decoding="async" src="@/assets/bandage.jpg" alt="Product 10"><h4>Bandage</h4></div>
        <div class="product"><img decoding="async" src="@/assets/Alcohol-96.jpg" alt="Product 10"><h4>Alcohol</h4></div>
    </div>
 
<div>
    <h2 class="references-title">NOS REFERENCES</h2>
    <div class="references-wrapper">
      <!-- Bouton Précédent -->
      <span class="nav-button prev-button" @click="prevReference">‹</span>
      

      <!-- Conteneur de références avec défilement -->
<div class="reference-container" :style="{ transform: `translateX(-${currentReferenceIndex * 100}%)` }">
  <div v-for="(ref, index) in references" :key="index" class="reference">
    <img :src="ref.logo" :alt="`Logo de ${ref.name}`" class="reference-logo" />
  </div>
</div>


      <!-- Bouton Suivant -->
      <span class="nav-button next-button" @click="nextReference">›</span>
    </div>
  </div>
  
</div>
   <!-- Icône de défilement -->
    <div id="scrollIcon" v-show="showScrollIcon" :style="{ opacity: iconOpacity }">
      <a @click.prevent="goToCertification">
        <img decoding="async" src="@/assets/certificats.png" alt="Icon">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeI',
  data() {
    return {
      videos: [
        require('@/assets/vid.mp4'),
      ],
    references: [
  { name: "Institut Pasteur Maroc", logo: require('@/assets/REFERENCE/INSTITUT PASTEUR MAROC.png') },
  { name: "Biolam", logo: require('@/assets/REFERENCE/BIOLAM.png') },
  { name: "Ain Itti", logo: require('@/assets/REFERENCE/CNSS.png') },
  { name: "Bank Al-Maghrib 1", logo: require('@/assets/REFERENCE/BANK ALMAGHRIB.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/CHU OUJDA.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/RMMS.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/LABO SOFI.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/CIAMM.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/ANFA LAB.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/DERDABI.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/CBM.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/PANORAMIQUE.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/LCN.png') },
  { name: "Bank Al-Maghrib 2", logo: require('@/assets/REFERENCE/LIAB.png') }, 
  
    ],
      currentIndex: 0,
      currentReferenceIndex: 0, // Pour les références
      referenceInterval: null,
      interval: null,
      showScrollIcon: true,  // Contrôle de l'affichage de l'icône
      iconOpacity: 1         // Opacité de l'icône
    };
  },
  mounted() {

    
    const video = document.getElementById('VideoWorker-0');
    if (video) {
      video.muted = true; // Force la vidéo à être muette
      video.loop = true;  // Force la boucle
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.controls = false; // Désactiver les contrôles de la vidéo
      
      // Lecture automatique avec gestion d'erreur
      video.play().catch(error => {
        console.log('La lecture automatique a été interrompue :', error);
      });

      // Ajouter un écouteur pour désactiver le plein écran lors du double-clic
      video.addEventListener('dblclick', this.disableFullscreen);

    }
     this.startAutoReferenceScroll();
  },
  
  beforeUnmount() {
   
    clearInterval(this.interval);
    const video = document.getElementById('VideoWorker-0');
    
    // Vérification si la vidéo existe avant de retirer l'écouteur d'événements
    if (video) {
      video.removeEventListener('dblclick', this.disableFullscreen);
    }
  
  },

  computed: {
  productsLoop(){ return [...this.products, ...this.products]; }
},

  methods: {
    goToCertification() {
      // Rediriger vers la page Qualité & Certifications
      this.$router.push('/qualite-certifications');
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    goToProduits() {
      this.$router.push('/produits');
    },
    goToProduitsV() {
      this.$router.push('/vitamines-mineraux');
    },
    toggleShowMore() {
      this.$router.push('/certification');
    },
    disableFullscreen(event) {
      event.preventDefault();
      event.stopPropagation();
    },
     nextReference() {
      // Avancer à la référence suivante
      this.currentReferenceIndex = (this.currentReferenceIndex + 1) % this.references.length;
    },
    prevReference() {
      // Revenir à la référence précédente
      this.currentReferenceIndex = (this.currentReferenceIndex - 1) % this.references.length;
    },
    startAutoVideoScroll() {
      // Défilement automatique des vidéos
      this.videoInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.videos.length;}, 2000); // Défilement toutes les 5 secondes
    },
    startAutoReferenceScroll() {
      // Défilement automatique des références
      this.referenceInterval = setInterval(this.nextReference, 3000); // Défilement toutes les 3 secondes
    },

  },
};

</script>


<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 800px;
}

.carousel-video {
  position: relative;
  min-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0px;
  pointer-events: none;
}

.carousel-text {
  position: absolute;
  top: 30%; 
  left: 50%;
  transform: translateX(-50%);
  color: #333;
  background-color: rgba(247, 247, 250, 0.864);
  padding: 0px 30px;
  font-size: 24px;
  text-align: center;
  z-index: 2;
  width: 70%;
  box-sizing: border-box;
  font-family: 'Helvetica', sans-serif;
  border-radius: 15px;
  animation: fadeIn 1.5s ease-in-out;
}

.welcome-title {
  font-size: 36px;
  color: #05305b;
  animation: fadeIn 3s ease-in-out infinite;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.welcome-description {
  font-size: 18px;
  margin-top: 10px;
  color: #555;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.custom-button {
  background-color: transparent;
  color: black;
  border: 2px solid #05305b;
  padding: 10px 20px;
  font-size: 18px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.4s ease;
}

.custom-button:hover {
  background-color: #05305b;
  color: white;
}

.button-description {
  color: #090c78;
  font-size: 14px;
  margin-top: -10px;
}

.carousel-prev,
.carousel-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 3;
  border-radius: 50%;
}

.carousel-prev {
  left: 10px;
}

.carousel-next {
  right: 10px;
}

.carousel-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
}

.carousel-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: white;
  cursor: pointer;
}

.carousel-dot.active {
  background-color: black;
}

.welcome-section {
  text-align: center;
  margin-top: 20px;
}

.welcome-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
}

.welcome-image-container {
  position: relative;
  max-width: 300px;
}

.welcome-heading {
  position: absolute;
  top: -30px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #090c78;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 15px;
  border-radius: 5px;
  animation: fadeIn 3s ease-in-out infinite;
}

.welcome-image {
  width: 100%;
  border-radius: 15px;
}

.welcome-text {
  font-size: 20px;
  color: #333;
  line-height: 1.5;
  text-align: left;
  max-width: 700px;
  font-weight: 300;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-bottom: 20px;
}

.read-more-btn {
  display: block;
  background-color: #05305b;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  margin-bottom: 30px; 
}

.read-more-btn:hover {
  background-color: #1a2073;
}

/* Animation */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Styles Modernes pour le Slider */

/* Conteneur principal */
.product-title{
  color:#090c78;
  font-size: 30px;
  margin-bottom: 50px; 
}


.product-wrapper {
  overflow: hidden;
  padding: 0 2vw; /* Un peu de padding pour l'espacement */
  margin-bottom: 50px; /* Ajout de marge en bas pour créer de l'espace avec le footer */
}

/* Animation du scroll */
.product-container {
  display:flex;
  animation: scroll 10s linear infinite;
  will-change: transform; /* Optimisation des performances */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-60%);
  }
}

/* Style des produits */
.product {
  flex: 0 0 auto; /* Permet aux éléments de rester sur une seule ligne */
  min-width: 84px;
  max-width: 15px; /* Limite la taille maximale des produits */
  margin-right: 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;
  padding: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

/* Ajustement des images */
.product img {
  max-width: 60%;
  height: auto;
  border-radius: 8px;
  transition: transform 0.3s;
}

.product:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.product:hover img {
  transform: scale(1.1);
}

#scrollIcon {
  position: fixed;
  bottom: 20px;
  left: 20px; /* Positionner à gauche */
  display: block;
  cursor: pointer;
  transition: opacity 0.5s ease;
}

#scrollIcon img {
  width: 30px; /* Ajustez la taille de l'icône si nécessaire */
  height: auto;
}

.references-section {
  text-align: center;

}

.references-title {
  font-size: 1.8em;
  text-align: center;
  margin: 40px 0 20px;
  color: #090c78;
  
}

.references-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 1300px; /* CHANGEMENT LARGEUR BUTTON*/ 
  margin: 0 auto;
}

.reference-container {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: calc(5% * 5); /* Ajustez selon le nombre de références */
}

.reference {
  text-align: center;
  width: 100%; /* Largeur d'une référence : 100% du conteneur visible */
  flex-shrink: 0;
  padding: 10px;
}

.reference-logo {
  width: 100px;
  height: auto;
  object-fit: contain;
}

.nav-button {
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 10px;
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.prev-button {
  left: 0px;
}

.next-button {
  right: 0px;
}

.nav-icon {
  width: 20px;
  height: 20px;
  filter: invert(1); /* Rendre l'icône blanche si elle est sombre */
}

.brochure-section {
  text-align: center;
  margin-top: 30px;
}


.brochure-section h2 {
  color:#05305b;
  font-size: 30px;
  margin-bottom: 20px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
} 


@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(224, 36, 11, 0.5);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(224, 36, 11, 0.8);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(224, 36, 11, 0.5);
  }
}

.brochure-button {
  display: inline-block;
  background-color: #e0240b;
  color: white;
  padding: 5px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  animation: pulse 2s infinite;
}

/* Effet au survol */
.brochure-button:hover {
  background-color: #c31e09;
  transform: scale(1.1);
}


.brochure-button i {
  margin-right: 8px;
}

/* Media Queries for responsiveness */



@media only screen and (max-width: 1300px) {

  .home-container {
    padding: 0px; /* Réduction des marges pour mieux s'adapter à l'écran */
    
  
  }

  .carousel {
    height: 440px; /* Ajustement de la hauteur du carrousel pour s'adapter aux petits écrans */
    right: -1px;
   

  }

  .carousel-text {
    top: 20%; /* Position ajustée pour centrer le texte sur les petits écrans */
    font-size: 16px; /* Taille de police réduite */
    width: 100%; /* Réduction de la largeur du texte */
    border-radius: 0px;
  }

  .welcome-title {
    font-size: 20px; /* Taille réduite pour s'adapter */
  }

  .welcome-description {
    font-size: 12px; /* Réduction de la taille pour une meilleure lisibilité */
  }

  .custom-button {
    font-size: 12px; 
    padding: 8px 18px; 
  }

  .button-description {
    font-size: 10px; 
  }

  .welcome-heading {
    font-size: 16px; 
  }

  .welcome-text {
    font-size: 14px; /* Texte un peu plus petit pour tenir mieux sur les petits écrans */
    max-width: 90%; /* Réduction de la largeur pour rester bien aligné */
    margin: 0 auto; 
  }

  .read-more-btn {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 12px;
    margin-top: 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
.product-wrapper{
  max-width: 700px;
}
.product-title{
  color:#090c78;
  font-size: 25px;
  margin-bottom: 20px; 
}

  .carousel-dot {
    display: none;
  }
  
  .brochure-section h2 {
    font-size: 22px;
  }

  .brochure-button {
    font-size: 14px;
    padding: 6px 16px;
  }
  
}

 
/* Small devices (mobile) */

@media screen and (max-width: 450px) {

  .home-container {
    padding: 0 0px; 
    
  }

  .carousel {
    height: 300px; 
    margin-top: 40px; 
  }
  .carousel-text {
    top: 0%; 
    font-size: 10px; 
    width: 100%; 
    padding: 10px; 
    border-radius: 0px;
  } 

  .welcome-title {
    font-size: 14px; 
  }

  .welcome-description {
    font-size: 10px; 
   
  }

  .custom-button {
    font-size: 6px; 
    padding: 4px 12px; 
   
  }

  .button-description {
    font-size: 6px; 

  }

  .welcome-heading {
    font-size: 10px; 
    padding: 10px;
    
  }

  .welcome-image {
    width: 115%;
    
  }

  .welcome-text {
    font-size: 10px; 
    max-width: 100%; 
    padding: 10px; 
  }
    .read-more-btn {
    padding: 4px 12px;
    cursor: pointer;
    font-size: 10px;
    margin-top: 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }

   .carousel-dot {
    display: none;
  }
.product-wrapper{
  max-width: 300px;
   margin-bottom: 50px; /* Ajout de marge en bas pour créer de l'espace avec le footer */
}

.product-title{
  color:#090c78;
  font-size: 20px;
  margin-bottom: 20px; 
}
.reference-container {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: calc(100% * 1); /* Ajustez selon le nombre de références */
  }

    .brochure-section h2 {
    font-size: 14px;
   
  }

  .brochure-button {
    font-size: 9px;
    padding: 3px 12px;
  }
}

/* ===================== MODE SOMBRE (prefers-color-scheme) ===================== */
@media (prefers-color-scheme: dark){
  /* Base */
  .home-container{ background:#0e1720; color:#e6edf1; }
  .carousel{ background:#0b1620; }
  .video-player{ filter: brightness(.9) contrast(1.05); } /* lisibilité vidéo */

  /* Bloc texte du hero */
  .carousel-text{
    background: rgba(16,24,32,.85);
    color:#dce8eb;
    border:1px solid rgba(255,255,255,.08);
  }
  .welcome-title{ color:#e5ecff; }        /* titre plus clair sur fond sombre */
  .welcome-description{ color:#bfd2d7; }

  /* CTA */
  .custom-button{
    background: transparent;
    color:#def7f3;
    border-color:#44b9ac;
    box-shadow: 0 8px 20px rgba(0,0,0,.35);
  }
  .custom-button:hover{
    background: linear-gradient(180deg,#00a897,#00998B);
    color:#fff;
    border-color: transparent;
  }
  .button-description{ color:#a6e3dd; }

  /* Bloc “Bienvenue” */
  .welcome-heading{
    background: rgba(16,24,32,.92);
    color:#dbeafe;
    border:1px solid rgba(255,255,255,.08);
  }
  .welcome-text{ color:#cfe0e4; }
  .read-more-btn{ background:#0aa393; }
  .read-more-btn:hover{ background:#0b8c7f; }

  /* Produits */
  .product-title{ color:#cde5ff; }
  .product{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 22px rgba(0,0,0,.5);
  }
  .product h4{ color:#e6edf1; }

  /* Références */
  .references-title{ color:#cde5ff; }
  .reference{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 22px rgba(0,0,0,.5);
  }
  .reference-logo{ filter:none; opacity:.95; } /* logos plus lisibles */

  /* Contrôles / dots */
  .nav-button{
    background: rgba(24,32,40,.9);
    color:#fff;
    border:1px solid rgba(255,255,255,.06);
  }
  .carousel-dot{
    background: rgba(255,255,255,.65);
    border:1px solid rgba(255,255,255,.25);
  }
  .carousel-dot.active{ background:#00b5a6; }

  /* Brochure */
  .brochure-section h2{ color:#e6edf1; }
}

/* ==== SLIDE PRODUITS – STYLE PRO ==== */

/* Titre */
.product-title{
  color:#05305b;
  font-weight:800;
  letter-spacing:.01em;
  font-size: clamp(20px, 2.2vw, 32px);
  text-align:center;
  margin: 28px 0 18px;
}

/* Wrapper : bords fondus + pause au hover */
.product-wrapper{
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0 2vw;
  margin: 0 auto 48px;
  --fadeW: 60px; /* largeur du fondu sur les côtés */
}
.product-wrapper::before,
.product-wrapper::after{
  content:"";
  position:absolute; top:0; bottom:0; width:var(--fadeW); z-index:2;
  pointer-events:none;
  background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));
}
.product-wrapper::after{
  right:0;
  transform: scaleX(-1);
}
.product-wrapper::before{ left:0; }

/* Piste : défilement fluide */
.product-container{
  display:flex; align-items:stretch; gap:16px;
  will-change: transform;
  animation: products-marquee 24s linear infinite;
}
.product-wrapper:hover .product-container{ animation-play-state: paused; }

/* Duplique tes items dans le template si tu veux une boucle parfaite */
@keyframes products-marquee{
  from{ transform: translateX(0); }
  to  { transform: translateX(-50%); } /* nécessite la liste dupliquée */
}

/* Carte produit */
.product{
  flex:0 0 auto;
  width: clamp(180px, 18vw, 240px);
  background:#fff;
  border:1px solid rgba(0,0,0,.06);
  border-radius:16px;
  padding:12px;
  text-align:center;
  box-shadow:0 10px 24px rgba(0,0,0,.08);
  transition: transform .2s ease, box-shadow .25s ease, filter .2s ease;
  outline: none;
}
.product:hover{
  transform: translateY(-4px);
  box-shadow:0 18px 36px rgba(0,0,0,.12);
}

/* Image : ratio propre + hover doux */
.product img{
  width:100%;
  aspect-ratio: 4/3;
  object-fit:cover;
  border-radius:12px;
  transition: transform .25s ease, filter .25s ease;
}
.product:hover img{ transform: scale(1.04); }

/* Titre / texte */
.product h4{
  margin:10px 0 0;
  font-size: .98rem;
  font-weight:700;
  color:#22313a;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}
.product p{
  margin:6px 0 0;
  font-size:.85rem;
  color:#5f6b73;
}

/* Focus clavier (accessibilité) */
.product:focus-visible{
  box-shadow: 0 0 0 3px rgba(0,153,139,.2), 0 10px 24px rgba(0,0,0,.1);
  transform: translateY(-2px);
}



/* ====== Dark mode propre ====== */
@media (prefers-color-scheme: dark){
  .product-title{ color:#cde5ff; }
  .product-wrapper::before,
  .product-wrapper::after{
    background: linear-gradient(to right, rgba(14,23,32,1), rgba(14,23,32,0));
  }
  .product{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow:0 10px 24px rgba(0,0,0,.5);
  }
  .product h4{ color:#e6edf1; }
  .product p{ color:#afc4c9; }
}

/* ==== Garder l'animation produits sur TOUTES les tailles ==== */

/* Marquee toujours actif */
.product-container{
  animation: products-marquee 24s linear infinite !important;
  will-change: transform;
  transform: translateZ(0);              /* lissage GPU mobile */
  backface-visibility: hidden;
}

/* Pause au survol (desktop) et au toucher (mobile) */
.product-wrapper:hover .product-container{ animation-play-state: paused; }
.product-wrapper:active .product-container{ animation-play-state: paused; }

/* Tablette : un peu plus lent = plus lisible */
@media (max-width: 1024px){
  .product-container{ animation-duration: 20s !important; }
}

/* Mobile */
@media (max-width: 640px){
  .product-container{ animation-duration: 20s !important; }
}

/* Supprime les overrides "scroll-snap" */
@media (max-width: 900px){
  .product-container{
    overflow: hidden !important;
    scroll-snap-type: none !important;
  }
}


/* ====== NOS RÉFÉRENCES ====== */

/* Titre */
.references-title{
  font-size: clamp(20px, 2vw, 30px);
  color:#05305b;
  font-weight: 800;
  letter-spacing:.01em;
  text-align:center;
  margin: 28px 0 18px;
}

/* Wrapper : bords fondus pour indiquer qu’il y a plus d’éléments */
.references-wrapper{
  position: relative;
  display:flex; align-items:center;
  overflow: hidden;
  width:100%;
  max-width:1200px;
  margin:0 auto 10px;
  padding: 8px 44px;              /* place pour les flèches */
  --fadeW: 60px;
}
.references-wrapper::before,
.references-wrapper::after{
  content:"";
  position:absolute; top:0; bottom:0; width:var(--fadeW);
  pointer-events:none; z-index:2;
  background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));
}
.references-wrapper::before{ left:0; }
.references-wrapper::after{ right:0; transform: scaleX(-1); }

/* Track géré par ton JS (transform: translateX(-index*100%)) */
.reference-container{
  display:flex; align-items:center;
  gap: 16px;
  will-change: transform;
  transition: transform .55s cubic-bezier(.22,.61,.36,1); /* glisse fluide */
}

/* Carte logo */
.reference{
  flex: 0 0 auto;
  width: clamp(160px, 18vw, 220px);   /* largeur d’une “carte” */
  padding: 12px;
  border-radius: 14px;
  background:#fff;
  border:1px solid rgba(0,0,0,.06);
  box-shadow: 0 10px 24px rgba(0,0,0,.08);
  display:flex; justify-content:center; align-items:center;
  transition: transform .2s ease, box-shadow .25s ease, filter .2s ease;
}
.reference:hover{
  transform: translateY(-3px);
  box-shadow: 0 16px 34px rgba(0,0,0,.12);
}

/* Logo */
.reference-logo{
  width: 100%;
  max-width: 140px;
  max-height: 70px;
  object-fit: contain;
  filter: grayscale(28%);
  opacity: .95;
  transition: filter .2s ease, opacity .2s ease, transform .2s ease;
}
.reference:hover .reference-logo{
  filter:none; opacity:1; transform: scale(1.03);
}

/* Flèches (prev/next) */
.nav-button{
  position:absolute; top:50%; transform: translateY(-50%);
  width: 40px; height: 40px; border-radius: 999px;
  display:grid; place-items:center; cursor:pointer; z-index:3;
  background:#fff; color:#0f1720;
  border:1px solid rgba(0,0,0,.08);
  box-shadow: 0 8px 22px rgba(0,0,0,.12);
  transition: transform .15s ease, background .2s ease, box-shadow .2s ease;
}
.nav-button:hover{ transform: translateY(-50%) scale(1.06); box-shadow: 0 12px 28px rgba(0,0,0,.16); }
.prev-button{ left: 8px; }
.next-button{ right: 8px; }

/* Petites optimisations responsive */
@media (max-width: 1024px){
  .references-wrapper{ padding: 8px 36px; --fadeW: 40px; }
  .reference{ width: clamp(150px, 26vw, 210px); }
}
@media (max-width: 640px){
  .references-wrapper{ padding: 6px 28px; --fadeW: 28px; }
  .reference{ width: clamp(140px, 58vw, 200px); }
  .reference-logo{ max-width: 120px; max-height: 60px; }
}

/* ====== Mode sombre ====== */
@media (prefers-color-scheme: dark){
  .references-title{ color:#cde5ff; }
  .references-wrapper::before,
  .references-wrapper::after{
    background: linear-gradient(to right, rgba(14,23,32,1), rgba(14,23,32,0));
  }
  .reference{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 10px 24px rgba(0,0,0,.5);
  }
  .nav-button{
    background: rgba(24,32,40,.92);
    color:#fff;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 22px rgba(0,0,0,.35);
  }
}

/* ===== Anti-scroll horizontal global (hors Références) ===== */

/* 1) Bloque le scroll horizontal sur la page */
:global(html, body){
  overflow-x: hidden;
  width: 100%;
}

/* 2) Empêche les gros blocs de dépasser (sauf Références) */
.home-container,
.carousel,
.welcome-section,
.product-wrapper{
  max-width: 100vw;
  overflow-x: hidden;
}

/* 3) Carrousel: retire le léger décalage qui faisait déborder */
@media (max-width: 1300px){
  .carousel{ right: auto !important; }
}

/* 4) Bloc texte du hero: jamais plus large que l’écran */
.carousel-text{ max-width: calc(100vw - 24px); }

/* 5) Image “Bienvenue” en mobile: 100%, pas 115% */
@media (max-width: 450px){
  .welcome-image{ width: 100% !important; }
  .carousel-text{ width: calc(100vw - 20px) !important; }
}

/* ===== Laisse la section RÉFÉRENCES intacte ===== */
.references-wrapper{ overflow: hidden; }        /* masque le débordement, mais ne casse pas l’anim */
.reference-container{ width: calc(5% * 5) !important; } /* restaure ta valeur d’origine */
.reference{ flex: 0 0 100% !important; }        /* chaque “slide” = 100% de la largeur visible */


</style>
